export const Page = [
    { title: "about" },
    { title: "repositories" },
];